module.exports = __webpack_public_path__ + "img/npc-logo.9ec0584d.jpg";